module.exports = __webpack_public_path__ + "static/media/max-India-Exp.321a98ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/max-India-Exp.jpg
// module id = 406
// module chunks = 0